
import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component({ name: 'SeparationLine' })
export default class SeparationLine extends Vue {
  @Prop({ default: '' }) id! : string
}
